// SMART DEMO — Mira Mutfak & Kafe asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 home-food + 4 breakfast + 4 dessert + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Mira Mutfak & Kafe" tamamen kurgu demo markadır.

export const MIRA_MUTFAK_ASSET_ROOT = "/demo-presets/food/mira-mutfak";

export interface MiraMutfakManifest {
  logo: string;
  homeFood: string[];
  breakfast: string[];
  dessert: string[];
  videos: string[];
}

export const MIRA_MUTFAK_MANIFEST: MiraMutfakManifest = {
  logo: `${MIRA_MUTFAK_ASSET_ROOT}/logo/logo.webp`,
  homeFood: [
    `${MIRA_MUTFAK_ASSET_ROOT}/home-food/01.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/home-food/02.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/home-food/03.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/home-food/04.webp`,
  ],
  breakfast: [
    `${MIRA_MUTFAK_ASSET_ROOT}/breakfast/01.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/breakfast/02.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/breakfast/03.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/breakfast/04.webp`,
  ],
  dessert: [
    `${MIRA_MUTFAK_ASSET_ROOT}/dessert/01.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/dessert/02.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/dessert/03.webp`,
    `${MIRA_MUTFAK_ASSET_ROOT}/dessert/04.webp`,
  ],
  videos: [
    `${MIRA_MUTFAK_ASSET_ROOT}/videos/01.mp4`,
    `${MIRA_MUTFAK_ASSET_ROOT}/videos/02.mp4`,
  ],
};